var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 1000,
    viewBox: "0 0 21.388 21.388",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "on",
    transform: "translate(-3275.641 -12184.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5130",
    "data-name": "Group 5130"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_356",
    "data-name": "Ellipse 356",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(3276.748 12184.5)",
    fill: "#31be3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-clockify",
    "data-name": "Icon simple-clockify",
    d: "M10.9,5.544l3.655-3.707L15.6,2.9,11.943,6.6,10.9,5.544Zm4.718,7.616-1.046,1.061-3.655-3.707,1.047-1.06Zm-6.16.555a5.458,5.458,0,0,0,2.082-.413l1.785,1.812a7.826,7.826,0,0,1-3.867,1.02A8.011,8.011,0,0,1,1.5,8.066,8.012,8.012,0,0,1,9.455,0a7.827,7.827,0,0,1,3.834,1L11.533,2.78a5.463,5.463,0,0,0-2.078-.412A5.623,5.623,0,0,0,3.884,8.042,5.623,5.623,0,0,0,9.455,13.715Z",
    transform: "translate(3274.58 12195.379) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2390",
    "data-name": "Path 2390",
    transform: "matrix(0.695, -0.719, 0.719, 0.695, 3289.251, 12191.592)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.07-.21h4v1h-4Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -0.06972360610961914 -0.2104352116584778 L 3.930276393890381 -0.2104352116584778 L 3.930276393890381 0.7895647287368774 L -0.06972360610961914 0.7895647287368774 L -0.06972360610961914 -0.2104352116584778 Z",
    stroke: "none",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOn);
export default __webpack_public_path__ + "static/media/on.500dca57.svg";
export { ForwardRef as ReactComponent };